export * from './adjunto.model';
export * from './adjunto-table.model';
